var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1180_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8105 9.74354V8.628C18.8105 4.03918 15.0897 0.318359 10.5003 0.318359C5.91082 0.318359 2.19 4.03918 2.19 8.628V9.74354",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.54868 9.74316H3.39795V15.396H1.54868C0.884313 15.396 0.345948 14.8576 0.345948 14.1933V10.9459C0.345948 10.2815 0.884313 9.74316 1.54868 9.74316Z",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4521 9.74316H17.6028V15.396H19.4521C20.1164 15.396 20.6548 14.8576 20.6548 14.1933V10.9459C20.6548 10.2815 20.1164 9.74316 19.4521 9.74316Z",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.93279 19.4614H9.27979",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.18945 16.7184V15.396",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.27961 19.4613C9.27961 20.1352 9.82625 20.6818 10.5002 20.6818C11.1741 20.6818 11.7207 20.1352 11.7207 19.4613C11.7207 18.7874 11.1741 18.2407 10.5002 18.2407C9.82625 18.2407 9.27961 18.7874 9.27961 19.4613Z",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.93262 19.4615C3.41744 19.4615 2.18925 18.2333 2.18925 16.7188",
    stroke: "white",
    strokeWidth: 0.636364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_1538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9453,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 20.9727 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHeadphones);
export default __webpack_public_path__ + "static/media/small-headphones.a4be19ce7a8177729fb03eadc7235794.svg";
export { ForwardRef as ReactComponent };